﻿export interface IEmailEntityDeleteRequest {
    emailTemplateId: number;
    emailEntityId: number;
}
